const U = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800`;

export const THEMES = {
  royal: { name: "Royal Gold", dark: true, bg: "#0B0A08", surface: "#16130E", text: "#F5EBD7", muted: "#A89B82", accent: "#D4A24C", hfont: "Cinzel", bfont: "Lora", hero: U("photo-1719862057229-4dd650b5ccee") },
  ivory: { name: "Ivory Classic", dark: false, bg: "#FBF7F0", surface: "#FFFFFF", text: "#2A2420", muted: "#7A6E62", accent: "#9C7A3C", hfont: "Cormorant Garamond", bfont: "Montserrat", hero: U("photo-1719862056552-b9de4f843beb") },
  rose: { name: "Rose Blush", dark: false, bg: "#FFF5F3", surface: "#FFFFFF", text: "#3B2327", muted: "#8E6A70", accent: "#B76E79", hfont: "Playfair Display", bfont: "Poppins", hero: U("photo-1735480166632-38176b26f212") },
  emerald: { name: "Emerald Luxe", dark: true, bg: "#0E1F1A", surface: "#152B24", text: "#EDE6D3", muted: "#9DB3A8", accent: "#C9A45C", hfont: "Marcellus", bfont: "Montserrat", hero: U("photo-1768845431893-8e28ed7bf79e") },
};

export const HEADING_FONTS = ["Cinzel", "Cormorant Garamond", "Playfair Display", "Marcellus", "Lora", "Great Vibes"];

export function themeVars(site) {
  const t = THEMES[site?.theme] || THEMES.royal;
  const accent = site?.accent || t.accent;
  return {
    theme: t,
    style: {
      "--bg": t.bg, "--surface": t.surface, "--text": t.text, "--muted": t.muted, "--accent": accent,
      "--line": `${accent}40`, "--hfont": `'${site?.heading_font || t.hfont}', serif`, "--bfont": `'${t.bfont}', sans-serif`,
      background: t.bg, color: t.text, fontFamily: `'${t.bfont}', sans-serif`,
    },
  };
}

export const siteHome = (site) => (site?.domain ? `https://${site.domain}` : `${window.location.origin}/store/${site?.slug}`);
export const siteCertUrl = (site, rid) => `${siteHome(site)}/certificate/${rid}`;
